import { render, staticRenderFns } from "./OrderProductMatrix.vue?vue&type=template&id=6c89a65d"
import script from "./OrderProductMatrix.vue?vue&type=script&lang=js"
export * from "./OrderProductMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports